import React from 'react'
import { ModalConsumerProps, ModalContext } from './ModalContext'

export function withModal<P extends ModalConsumerProps, T>(Component: React.ComponentType<P>) {
  return React.forwardRef<T, Omit<P, 'showDialog' | 'showModal'>>((props, ref) => (
    <ModalContext.Consumer>{modalProps => <Component {...(props as P)} {...modalProps} ref={ref} />}</ModalContext.Consumer>
  ))
}
